import { useEffect, } from 'react';
import { useLocation } from 'react-router';
import { collection, addDoc, } from 'firebase/firestore';

import { db, } from '../../firebase';

export default function usePageViewTracking ({ user, firebaseUser, }) {
  const location = useLocation();

  useEffect(() => {
    if (!firebaseUser || !user) return;

    const recordPageView = async () => {
      try {
        await addDoc(collection(db, 'pageViews'), {
          userId: firebaseUser.uid,
          tenantId: user.tenantId,
          path: location.pathname,
          search: location.search,
          createdAt: new Date(),
          userAgent: navigator.userAgent,
          isAdmin: user.admin || false,
        });
      } catch (e) {
        console.error('Failed to record page view:', e);
      }
    };

    recordPageView();
  }, [location.pathname, firebaseUser, user]);
};
